import { Button, Navbar } from 'reactstrap';
import styled from 'styled-components';
import CompassIcon from '../icons/CompassIcon';
import LayersIcon from '../icons/LayersIcon';
import SectionsIcon from '../icons/SectionsIcon';

const BottomNavbar = styled(Navbar)`
  z-index: 200;
`;

const NavButton = styled(({ icon, children, onClick, className }) => {
  return (
    <Button
      color="link"
      size="sm"
      onClick={onClick}
      className={`${className} font-tiny`}
    >
      <div>{icon}</div>
      {children}
    </Button>
  );
})`
  ${({ active }) => active && 'font-weight: bold; color: var(--text-color);'}
  svg {
    width: 1rem;
    height: 1rem;
  }
`;

const MobileNavbar = ({ view, setView }) => {
  return (
    <BottomNavbar
      className="justify-content-around"
      fixed="bottom"
      color="secondary"
    >
      <NavButton
        onClick={() => setView('map')}
        icon={<CompassIcon />}
        active={['map', 'fullscreen-map'].includes(view)}
      >
        Explore
      </NavButton>
      <NavButton
        onClick={() => setView('sections')}
        icon={<SectionsIcon />}
        active={view === 'sections'}
      >
        Sections
      </NavButton>
      <NavButton
        onClick={() => setView('layers')}
        icon={<LayersIcon />}
        active={view === 'layers'}
      >
        Layers
      </NavButton>
    </BottomNavbar>
  );
};

export default MobileNavbar;
